import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";


export default function Navbar() {
  return (
    <nav
      className="navbar navbar-expand-lg fixed-top"
      style={{
        background: "rgba(0, 0, 0, 0.35)",
        backdropFilter: "blur(8px)",
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
      }}
    >
      <div className="container">
        {/* ✅ Logo + Brand */}
        <a
          className="navbar-brand fw-bold d-flex align-items-center gap-2 text-white"
          href="/"
          style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
        >
          <img
            src="/demoimage.png"
            alt="Digital Ledger Media Logo"
            width="45"
            height="45"
            className="d-inline-block align-text-top"
            style={{ objectFit: "contain" }}
          />
          <span>Digital Ledger Media</span>
        </a>

        {/* ✅ Mobile Toggle */}
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navMenu"
          aria-controls="navMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
          style={{ filter: "invert(1)" }}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* ✅ Menu Links */}
        <div className="collapse navbar-collapse" id="navMenu">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center">
            {[
              { name: "About Us", href: "#about" },
              // { name: "Pricing", href: "#pricing" },
              
            ].map((item, index) => (
              <li className="nav-item" key={index}>
                <a
                  className="nav-link px-3 fw-semibold text-white"
                  href={item.href}
                  style={{
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.color = "rgba(255,140,0,1)")
                  }
                  onMouseLeave={(e) => (e.target.style.color = "#fff")}
                >
                  {item.name}
                </a>
              </li>
              
            ))}
            
<li className="nav-item">
  <Link
    className="nav-link px-3 fw-semibold text-white"
    to="/finacialservice/Influencer-Campaign-Strategy"
    style={{ transition: "color 0.3s ease" }}
    onMouseEnter={(e) => (e.target.style.color = "rgba(255,140,0,1)")}
    onMouseLeave={(e) => (e.target.style.color = "#fff")}
  >
    Digital Solution
  </Link>
  
</li>


<li className="nav-item">
 <Link
    className="nav-link px-3 fw-semibold text-white"
    to="/Financial"
    style={{ transition: "color 0.3s ease" }}
    onMouseEnter={(e) => (e.target.style.color = "rgba(255,140,0,1)")}
    onMouseLeave={(e) => (e.target.style.color = "#fff")}
  >
    Financial Intelligence
  </Link>
  
</li>
<li className="nav-item">
  <Link
    className="nav-link px-3 fw-semibold text-white"
    to="/influencer"
    style={{ transition: "color 0.3s ease" }}
    onMouseEnter={(e) => (e.target.style.color = "rgba(255,140,0,1)")}
    onMouseLeave={(e) => (e.target.style.color = "#fff")}
  >
    Influencer
  </Link>
  
</li>
<li className="nav-item">
  <Link
    className="nav-link px-3 fw-semibold text-white"
    to="/contact"
    style={{ transition: "color 0.3s ease" }}
    onMouseEnter={(e) => (e.target.style.color = "rgba(255,140,0,1)")}
    onMouseLeave={(e) => (e.target.style.color = "#fff")}
  >
    Contact Us
  </Link>
  
</li>
            {/* ✅ Gradient Button */}
            <li className="nav-item mt-2 mt-lg-0">
              <motion.a
                href="#contact"
                className="btn fw-semibold px-4 py-2 ms-lg-3"
                style={{
                  background:
                    "linear-gradient(90deg, rgba(255,0,110,1) 0%, rgba(255,140,0,1) 100%)",
                  border: "none",
                  color: "#fff",
                  borderRadius: "50px",
                  boxShadow: "0 4px 15px rgba(255,0,110,0.25)",
                  transition: "all 0.3s ease",
                }}
                whileHover={{
                  scale: 1.08,
                  boxShadow: "0 10px 25px rgba(255,0,110,0.35)",
                }}
                whileTap={{ scale: 0.97 }}
              >
                Get Started
              </motion.a>
            </li>
            
          </ul>
        </div>
      </div>
    </nav>
  );
}
